const NewsItem = (item) => {
    var onClick = () => {
        if (!item.url) {
            // Open modal when no URL is provided
            const button = document.createElement('button');
            button.setAttribute('data-bs-toggle', 'modal');
            button.setAttribute('data-bs-target', '#newsDetailModal');
            button.setAttribute('data-news', JSON.stringify(item));
            button.style.display = 'none';
            document.body.appendChild(button);
            button.click();
            document.body.removeChild(button);
        } else if (item.target === '_blank') {
            window.open(item.url, '_blank');
        } else {
            window.location.href = item.url;
        }
    };

    const getTypeDisplayName = (type) => {
        switch (type) {
            case 'event':
                return 'Event';
            case 'release':
                return 'Release';
            default:
                return 'News';
        }
    };
    return (
        <div
            className="card h-100"
            onClick={onClick}
            style={{ cursor: 'pointer' }}
        >
            <div className="card-body d-flex flex-column">
                <div className="row mb-2">
                    <div className="col">
                        {item.type === 'event' ? (
                            <span className="badge bg-danger me-2">{getTypeDisplayName(item.type)}</span>
                        ) : item.type === 'news' ? (
                            <span className="badge bg-success me-2">{getTypeDisplayName(item.type)}</span>
                        ) : item.type === 'release' ? (
                            <span className="badge bg-secondary me-2">{getTypeDisplayName(item.type)}</span>
                        ) : (
                            <span className="text-body-secondary small">{getTypeDisplayName(item.type)}</span>
                        )}
                    </div>
                    <div className="col-auto">
                        <span className="text-body-secondary small">{item.date}</span>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col">
                        {item.titleImg && (
                            <img src={item.titleImg} alt={item.title} className="img-fluid news-title-img mx-1 my-2" />
                        )}
                        <span className="text-body-secondarycard-title">{item.title}</span>
                    </div>
                </div>
                <div className="row flex-grow-1">
                    <div className="col">
                        <h5 className="mb-2">{item.header}</h5>
                        {item.shortDescription && (
                            <p 
                                className="text-muted small mb-0" 
                                dangerouslySetInnerHTML={{ __html: item.shortDescription }}
                                onClick={(e) => {
                                    // Prevent modal from opening when clicking on links
                                    if (e.target.tagName === 'A') {
                                        e.stopPropagation();
                                    }
                                }}
                            ></p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewsItem;